import { Service } from 'typedi';

import { TokenType } from '../../../models/enums/general-enums';
import { IPendingAutoLoginModel } from '../models';
import { AutoLoginDataBuilder } from './autologindata.builder.service';

@Service()
export class PendingAutoLoginDataBuilder extends AutoLoginDataBuilder<IPendingAutoLoginModel> {
    public Build = async (data: any): Promise<IPendingAutoLoginModel> => {
        const { clientVersion, productPackage } = this._window.pageContextManager.getDeviceData();
        const { brandId, subBrandId } = this._window.pageContextManager.getBrandData();
        let loginModel: IPendingAutoLoginModel = {
            AuthenticationInfo: JSON.stringify({
                TokenData: {
                    TokenType: TokenType.Regular,
                    TokenValue: decodeURIComponent(data.Token),
                },
            }),
            EncryptionType: String(data?.EncryptionType ?? undefined),
            SourceProductPackage: 27,
            ClientVersion: clientVersion,
            TargetProductPackage: productPackage,
            BrandID: brandId,
            TargetSubBrand: subBrandId,
            ...(this.shouldSendLoginCountry() && {
                LoginCountryISO3: this._window.pageContextManager.getGlobalizationData().country,
            }),
        };

        loginModel = await this._setLoginNativeProps(loginModel);

        return loginModel;
    };
}
